import { QuoteApi } from './QuoteApi';
import { Log } from '@lightningjs/sdk';
import { BaseCachedApi } from '../BaseCachedApi';
import { Backend } from '../Backend';
import { IValidQuotePriceResponse3 } from '../models/AndromeTV.types';
import { SettingsKeys } from '../models/TranslationKeys';

export class CachedQuoteApi extends BaseCachedApi {
  private catalogId: string | undefined;
  protected override _cache: IValidQuotePriceResponse3[] | undefined;

  constructor(private backend: Backend) {
    super();
    this.updateGlobalSettings();
  }

  private updateGlobalSettings() {
    this.updateExpirations(
      this.backend.globalSettings.numberValue(SettingsKeys.quoteCacheExpiration) ?? 600000,
      this.backend.globalSettings.numberValue(SettingsKeys.quoteCacheErrorExpiration) ?? 300000
    );
  }

  /**
   * Retrieve a list of valid quotes from the backend
   */
  list(backend: Backend, catalogId?: string): Promise<IValidQuotePriceResponse3[]> {
    this.catalogId = catalogId;
    const prom = this.checkCache(backend);

    return prom.then(() => this._cache) as Promise<IValidQuotePriceResponse3[]>;
  }

  override fillCache(backend: Backend): Promise<IValidQuotePriceResponse3[]> {
    Log.info('[CachedQuotesApi]', 'refreshing, bypass:', this._bypassCache);
    this.updateGlobalSettings();
    return QuoteApi.list(backend, this.catalogId).then(list => {
      this.clearCache();
      this._cache = list;
      return list;
    });
  }

  addQuoteToCache(quote: IValidQuotePriceResponse3): void {
    this._cache?.push(quote);
  }
}
